export default "__VITE_ASSET__CtDnqeMg__"